@if ((isHeaderEmpty$ | async) === false) {
  <div class="header flex" [ngStyle]="headerStyle">
    <div [blazeSlotNode]="slots?.slotNodesData?.header" class="flex-auto">
      <ng-container *ngTemplateOutlet="slots?.templates?.header || null" />
    </div>
  </div>
}

@if (!isCloseButtonHidden()) {
  <button
    #closeButton
    class="close-dialog"
    (mousedown)="closeDialog($event)"
    data-cy="DialogElement:close"
  >
    <mat-icon svgIcon="icon_close_16" />
  </button>
}

<div
  class="content"
  [class.close-affordance]="!isCloseButtonHidden() && (isHeaderEmpty$ | async)"
  [ngStyle]="contentStyle"
  [blazeSlotNode]="slots?.slotNodesData?.content"
>
  <ng-container
    *ngTemplateOutlet="
      slots?.templates?.content || null;
      context: { elementContext: { viewType: 'dialog' } }
    "
  />
</div>

@if (
  (isFooterEmpty$ | async) === false && slots?.slotNodesData?.footer && slots?.templates?.footer
) {
  <div class="footer" [ngStyle]="footerStyle" [blazeSlotNode]="slots?.slotNodesData?.footer">
    <ng-container *ngTemplateOutlet="slots?.templates?.footer || null" />
  </div>
}
